import React from 'react'
import { Button } from 'react-bootstrap';
import { AnimationType, getAnimationClass } from '../../presentation/constants/AnimationType';
import { useDispatch, useSelector } from 'react-redux';
import { SaleActions } from '../../presentation/redux/actions/SaleActions';
import { ModalStep } from '../../presentation/redux/states/SaleState';
import { SkuLabelTicket } from './SkuLabelTicket';
import PropTypes from 'prop-types';
import { RequestParam } from '../../domain/models/RequestParam';
import { RootState } from '../../presentation/redux/store/RootState';

export const SkuSaleConfirmation = (
    {
        step,
        params,
        pos,
        token
    }: any
) => {

    const state = useSelector((s: RootState) => s.saleState);
    const dispatch = useDispatch();

    return (
        <div className={getAnimationClass(AnimationType.NONE)}>
            <h4 className='text-center'>Confirmación de compra</h4>
            <div className='my-4'>
                {
                    params.map((p: RequestParam) => {
                        if (!p.isHidden) {
                            return <SkuLabelTicket
                                key={p.name}
                                label={p.description}
                                value={p.value} />
                        }
                        return <></>
                    })
                }
            </div>

            <Button variant="link" className="float-left ml-4  mt-4"
                disabled={state.loader.isLoading}
                onClick={() => {
                    dispatch(SaleActions.prevStep(step, ModalStep.CONFIRM));
                }}> Regresar </Button>

            <Button
                variant="primary" className="float-right mr-4  mt-4"
                disabled={state.loader.isLoading}
                onClick={() => {
                    if (state.sku?.sku === 'ACCESOD_ACTIVACION') {
                        dispatch(SaleActions.processActivationPayment(params, state.sku.sku, pos, token));
                    } else {
                        dispatch(SaleActions.processPayment(params, pos, token));
                    }
                }}
                type="submit"> COMPRAR </Button>



        </div>
    )
}

SkuSaleConfirmation.propTypes = {
    step: PropTypes.number.isRequired,
    params: PropTypes.arrayOf(PropTypes.instanceOf(RequestParam)).isRequired,
    pos: PropTypes.string.isRequired,
    token: PropTypes.string.isRequired
}